/* tslint: disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v7.1.6162.22205 (NJsonSchema v5.16.6156.29215) (http://NSwag.org)
// </auto-generated>
//----------------------

//import 'rxjs/Rx'; 
import {Observable} from 'rxjs/Observable';
import {Injectable, Inject, Optional, InjectionToken} from '@angular/core';
import {Http, Headers, Response, RequestOptionsArgs} from '@angular/http';
import { HydrogenAppConfigService } from '../host.config.service';

export const API_BASE_URL = new InjectionToken('API_BASE_URL');

@Injectable()
export class PolicyApiService {
    private http: Http = null; 
    private baseUrl: string = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(configSvc: HydrogenAppConfigService, @Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = configSvc.config.serviceUrl.policy;
    }

    getpolicyById(policyId: string): Observable<PolicyModel> {
        let url_ = this.baseUrl + "/api/policy/id/{policyId}"; 

        if (policyId === undefined || policyId === null)
            throw new Error("The parameter 'policyId' must be defined.");
        url_ = url_.replace("{policyId}", encodeURIComponent("" + policyId)); 

        const content_ = "";
        
        return this.http.request(url_, {
            body: content_,
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json; charset=UTF-8"
            })
        }).map((response) => {
            return this.processGetpolicyById(response);
        }).catch((response: any, caught: any) => {
            if (response instanceof Response) {
                try {
                    return Observable.of(this.processGetpolicyById(response));
                } catch (e) {
                    return <Observable<PolicyModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<PolicyModel>><any>Observable.throw(response);
        });
    }

    private processGetpolicyById(response: Response) {
        const data = response.text();
        const status = response.status.toString(); 

        if (status === "200") {
            let result200: PolicyModel = null; 
            let resultData200 = data === "" ? null : JSON.parse(data, this.jsonParseReviver);
            result200 = resultData200 ? PolicyModel.fromJS(resultData200) : null;
            return result200; 
        }
        else
        {
            throw new Error("error_no_callback_for_the_received_http_status"); 
        }
    }

    many(search: PolicySearch): Observable<PolicyModel[]> {
        let url_ = this.baseUrl + "/api/policy/many"; 

        const content_ = JSON.stringify(search ? search.toJS() : null);
        
        return this.http.request(url_, {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json; charset=UTF-8"
            })
        }).map((response) => {
            return this.processMany(response);
        }).catch((response: any, caught: any) => {
            if (response instanceof Response) {
                try {
                    return Observable.of(this.processMany(response));
                } catch (e) {
                    return <Observable<PolicyModel[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<PolicyModel[]>><any>Observable.throw(response);
        });
    }

    private processMany(response: Response) {
        const data = response.text();
        const status = response.status.toString(); 

        if (status === "200") {
            let result200: PolicyModel[] = null; 
            let resultData200 = data === "" ? null : JSON.parse(data, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PolicyModel.fromJS(item));
            }
            return result200; 
        }
        else
        {
            throw new Error("error_no_callback_for_the_received_http_status"); 
        }
    }

    create(data: PolicyModel): Observable<PolicyModel> {
        let url_ = this.baseUrl + "/api/policy/create"; 

        const content_ = JSON.stringify(data ? data.toJS() : null);
        
        return this.http.request(url_, {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json; charset=UTF-8"
            })
        }).map((response) => {
            return this.processCreate(response);
        }).catch((response: any, caught: any) => {
            if (response instanceof Response) {
                try {
                    return Observable.of(this.processCreate(response));
                } catch (e) {
                    return <Observable<PolicyModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<PolicyModel>><any>Observable.throw(response);
        });
    }

    private processCreate(response: Response) {
        const data = response.text();
        const status = response.status.toString(); 

        if (status === "200") {
            let result200: PolicyModel = null; 
            let resultData200 = data === "" ? null : JSON.parse(data, this.jsonParseReviver);
            result200 = resultData200 ? PolicyModel.fromJS(resultData200) : null;
            return result200; 
        }
        else
        {
            throw new Error("error_no_callback_for_the_received_http_status"); 
        }
    }

    update(data: PolicyModel): Observable<PolicyModel> {
        let url_ = this.baseUrl + "/api/policy/update"; 

        const content_ = JSON.stringify(data ? data.toJS() : null);
        
        return this.http.request(url_, {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json; charset=UTF-8"
            })
        }).map((response) => {
            return this.processUpdate(response);
        }).catch((response: any, caught: any) => {
            if (response instanceof Response) {
                try {
                    return Observable.of(this.processUpdate(response));
                } catch (e) {
                    return <Observable<PolicyModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<PolicyModel>><any>Observable.throw(response);
        });
    }

    private processUpdate(response: Response) {
        const data = response.text();
        const status = response.status.toString(); 

        if (status === "200") {
            let result200: PolicyModel = null; 
            let resultData200 = data === "" ? null : JSON.parse(data, this.jsonParseReviver);
            result200 = resultData200 ? PolicyModel.fromJS(resultData200) : null;
            return result200; 
        }
        else
        {
            throw new Error("error_no_callback_for_the_received_http_status"); 
        }
    }

    delete(id: string): Observable<any> {
        let url_ = this.baseUrl + "/api/policy/delete/{id}"; 

        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 

        const content_ = "";
        
        return this.http.request(url_, {
            body: content_,
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json; charset=UTF-8"
            })
        }).map((response) => {
            return this.processDelete(response);
        }).catch((response: any, caught: any) => {
            if (response instanceof Response) {
                try {
                    return Observable.of(this.processDelete(response));
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response);
        });
    }

    private processDelete(response: Response) {
        const data = response.text();
        const status = response.status.toString(); 

        if (status === "200") {
            let result200: any = null; 
            let resultData200 = data === "" ? null : JSON.parse(data, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200; 
        }
        else
        {
            throw new Error("error_no_callback_for_the_received_http_status"); 
        }
    }
}

export class PolicyModel { 
    id: string; 
    name: string; 
    accountId: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["id"] !== undefined ? data["id"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.accountId = data["AccountId"] !== undefined ? data["AccountId"] : null;
        }
    }

    static fromJS(data: any): PolicyModel {
        return new PolicyModel(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["id"] = this.id !== undefined ? this.id : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["AccountId"] = this.accountId !== undefined ? this.accountId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        var json = this.toJSON();
        return new PolicyModel(JSON.parse(json));
    }
}

export class PolicySearch { 
    accountId: string; 
    page: number; 
    pagesize: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.accountId = data["AccountId"] !== undefined ? data["AccountId"] : null;
            this.page = data["page"] !== undefined ? data["page"] : null;
            this.pagesize = data["pagesize"] !== undefined ? data["pagesize"] : null;
        }
    }

    static fromJS(data: any): PolicySearch {
        return new PolicySearch(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["AccountId"] = this.accountId !== undefined ? this.accountId : null;
        data["page"] = this.page !== undefined ? this.page : null;
        data["pagesize"] = this.pagesize !== undefined ? this.pagesize : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        var json = this.toJSON();
        return new PolicySearch(JSON.parse(json));
    }
}


// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/services/Crestron.HydrogenAPI.PolicyApi.service.ts